import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "menuButton", "menu", "navbar", "wrapper" ]
  static values = { navbarColored: Boolean, menuShow: Boolean }

  async connect() {
    const dummy = document.querySelector('#dummy')
    if (dummy) {
      let callback = (entries, observer) => {
        const entry = entries[0]
        const element = document.querySelector('#header')
        if (entry.isIntersecting) {
          element.classList.remove('navbar-colored')
        } else {
          element.classList.add('navbar-colored')
        }
      }
      this.observer = new IntersectionObserver(callback, { threshold: 1.0 })
      this.observer.observe(dummy)
    }

    this.updateLayout = () => {
      this.updateHeaderOffset()

      if (this.hasWrapperTarget) {
        this.wrapperTarget.style.paddingBottom = `${this.navbarTarget.offsetHeight}px`
      }
    }

    // Static announcements scroll with the page; keep the fixed header right
    // below them until they are gone, then pin it back to the top.
    this.scrollHandler = () => this.updateHeaderOffset()
    window.addEventListener('scroll', this.scrollHandler, { passive: true })

    // React to any header height change: announcement/verification banners,
    // image banners loading, countdown wrapping, Turbo morph refreshes, ...
    this.resizeObserver = new ResizeObserver(this.updateLayout)
    this.resizeObserver.observe(this.navbarTarget)

    const staticAnnouncements = document.getElementById('static-announcements')
    if (staticAnnouncements) {
      this.resizeObserver.observe(staticAnnouncements)
    }

    this.updateLayout()
  }

  updateHeaderOffset() {
    const staticAnnouncements = document.getElementById('static-announcements')
    const bottom = staticAnnouncements ? staticAnnouncements.getBoundingClientRect().bottom : 0

    this.navbarTarget.style.top = `${Math.max(0, bottom)}px`
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    window.removeEventListener('scroll', this.scrollHandler)
  }

  showMenu(event) {
    event.preventDefault()
    this.menuShowValue = true
  }

  hideMenu(event) {
    event.preventDefault()
    this.menuShowValue = false
  }

  toggleMenu(event) {
    event.preventDefault()
    this.menuShowValue = !this.menuShowValue
  }

  menuShowValueChanged() {
    if (this.menuShowValue) {
      this.menuTarget.classList.remove('invisible')
      this.navbarTarget.classList.add('navbar-colored-menu')
    } else {
      this.menuTarget.classList.add('invisible')
      this.navbarTarget.classList.remove('navbar-colored-menu')
    }
  }

  navbarColoredValueChanged() {
    if (this.navbarColoredValue) {
      this.navbarTarget.classList.remove('navbar-colored')
    } else {
      this.navbarTarget.classList.add('navbar-colored')
    }
  }
}
